export default "__VITE_ASSET__eaatNHCw__"